import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HugeiconsIconComponent, IconSvgObject } from '@hugeicons/angular';

export type IconSizes = 'xs' | 's' | 'm' | 'l' | 'xl';

@Component({
  selector: 'ptl-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [HugeiconsIconComponent],
})
export class IconComponent {
  @Input() icon?: IconSvgObject;
  @Input() size: IconSizes = 'm';

  readonly sizeMap: Record<IconSizes, number> = {
    xs: 16,
    s: 16,
    m: 20,
    l: 24,
    xl: 24,
  };
}
